import React from 'react'
import { useTranslation } from 'react-i18next';

export const STATUS_CONFIG = {
  reported: { label: 'Reported', bg: '#dbeafe', color: '#1d4ed8' },
  new: { label: 'Reported', bg: '#dbeafe', color: '#1d4ed8' }, // alias for backward compat
  open: { label: 'Open', bg: '#dcfce7', color: '#15803d' },
  review: { label: 'Under Review', bg: '#fef3c7', color: '#92400e' },
  investigation: { label: 'Investigation', bg: '#e0e7ff', color: '#4338ca' },
  evaluation: { label: 'Evaluation', bg: '#c7d2fe', color: '#4f46e5' },
  negotiation: { label: 'Negotiation', bg: '#fce7f3', color: '#9d174d' },
  approved: { label: 'Approved', bg: '#d1fae5', color: '#065f46' },
  denied: { label: 'Denied', bg: '#fee2e2', color: '#991b1b' },
  closed: { label: 'Closed', bg: '#f1f5f9', color: '#64748b' },
};

const STATUS_LABEL_KEYS = {
  reported: 'screens.claimsScreen.statusReported',
  new: 'screens.claimsScreen.statusReported',
  open: 'screens.claimsScreen.statusOpen',
  review: 'screens.claimsScreen.statusReview',
  investigation: 'screens.claimsScreen.statusInvestigation',
  evaluation: 'screens.claimsScreen.statusEvaluation',
  negotiation: 'screens.claimsScreen.statusNegotiation',
  approved: 'screens.claimsScreen.statusApproved',
  denied: 'screens.claimsScreen.statusDenied',
  closed: 'screens.claimsScreen.statusClosed',
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.reported;
  const labelKey = STATUS_LABEL_KEYS[status] || STATUS_LABEL_KEYS.reported;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 20,
        fontSize: 12,
        fontWeight: 600,
        background: cfg.bg,
        color: cfg.color,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: '50%', background: cfg.color }} />
      {t(labelKey)}
    </span>
  );
};

export default StatusBadge
